(function () {
  'use strict';

  var EMAILJS_PUBLIC_KEY = 'dFW9Q7iu6dfAyZ1vJ';
  var EMAILJS_SERVICE_ID = 'service_7f21ufc';
  var EMAILJS_TEMPLATE_ID = 'template_8ndsc9d';
  var CUPOM_DE_DESCONTO = 'PRIMEIRACOMPRA10';

  var STORAGE_DISMISSED = 'popup-lead-dismissed';
  var STORAGE_SUBMITTED = 'popup-lead-submitted';
  var emailJsReady = false;

  function parseDays(value, fallback) {
    var days = parseInt(value, 10);
    return isNaN(days) || days < 0 ? fallback : days;
  }

  function storageAvailable() {
    try {
      var key = '__pl_test__';
      window.localStorage.setItem(key, '1');
      window.localStorage.removeItem(key);
      return true;
    } catch (e) {
      return false;
    }
  }

  function readStamp(key) {
    if (!storageAvailable()) return null;
    try {
      var raw = window.localStorage.getItem(key);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || typeof data.expires !== 'number') return null;
      if (Date.now() > data.expires) {
        window.localStorage.removeItem(key);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function writeStamp(key, days) {
    if (!storageAvailable()) return;
    try {
      var expires =
        days === 0
          ? Date.now() + 4 * 60 * 60 * 1000
          : Date.now() + days * 24 * 60 * 60 * 1000;
      window.localStorage.setItem(
        key,
        JSON.stringify({ expires: expires, at: Date.now() })
      );
    } catch (e) {
      /* ignore */
    }
  }

  function shouldSkip(root) {
    if (root.dataset.forceOpen === 'true') return false;
    if (readStamp(STORAGE_SUBMITTED)) return true;
    if (readStamp(STORAGE_DISMISSED)) return true;
    return false;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(value || '').trim());
  }

  function initEmailJs() {
    if (emailJsReady) return true;
    if (!window.emailjs || typeof window.emailjs.init !== 'function') return false;
    try {
      window.emailjs.init({ publicKey: EMAILJS_PUBLIC_KEY });
      emailJsReady = true;
      return true;
    } catch (e) {
      try {
        window.emailjs.init(EMAILJS_PUBLIC_KEY);
        emailJsReady = true;
        return true;
      } catch (e2) {
        return false;
      }
    }
  }

  function sendWithEmailJs(params) {
    if (initEmailJs() && typeof window.emailjs.send === 'function') {
      return window.emailjs
        .send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, params)
        .then(function () {
          return true;
        })
        .catch(function () {
          return sendWithEmailJsFetch(params);
        });
    }
    return sendWithEmailJsFetch(params);
  }

  function sendWithEmailJsFetch(params) {
    var payload = {
      service_id: EMAILJS_SERVICE_ID,
      template_id: EMAILJS_TEMPLATE_ID,
      user_id: EMAILJS_PUBLIC_KEY,
      template_params: params
    };

    return fetch('https://api.emailjs.com/api/v1.0/email/send', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.ok;
    }).catch(function () {
      return false;
    });
  }

  function sendWithShopifyContact(emailVal, formTag) {
    var formData = new FormData();
    formData.append('form_type', 'contact');
    formData.append('utf8', '✓');
    formData.append('contact[email]', emailVal);
    formData.append('contact[subject]', formTag || 'Popup Lead — 10% OFF');
    formData.append(
      'contact[body]',
      [
        'Novo lead pelo popup da loja',
        '',
        'E-mail: ' + emailVal,
        'Cupom: ' + CUPOM_DE_DESCONTO,
        '',
        'Origem: Popup Lead'
      ].join('\n')
    );

    var action =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'contact'
        : '/contact';

    return fetch(action, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.status < 500;
      })
      .catch(function () {
        return false;
      });
  }

  var bodyScrollY = 0;

  function lockBody(lock) {
    if (lock) {
      bodyScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add('popup-lead-locked');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + bodyScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    } else {
      document.body.classList.remove('popup-lead-locked');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, bodyScrollY);
    }
  }

  function initPopupLead(root) {
    if (!root || root.dataset.plInitialized === 'true') return;
    root.dataset.plInitialized = 'true';

    var dialog = root.querySelector('[data-pl-dialog]');
    var form = root.querySelector('.popup-lead__form');
    var messageEl = root.querySelector('[data-pl-message]');
    var submitBtn = root.querySelector('[data-pl-submit]');
    var closeButtons = root.querySelectorAll('[data-pl-close]');
    var delay = parseInt(root.dataset.delay, 10) || 0;
    var dismissDays = parseDays(root.dataset.dismissDays, 7);
    var submitDays = parseDays(root.dataset.submitDays, 30);
    var openTimer = null;
    var isOpen = false;
    var submitting = false;

    if (root.parentNode !== document.body) {
      document.body.appendChild(root);
    }

    function setMessage(text, type) {
      if (!messageEl) return;
      messageEl.textContent = text || '';
      messageEl.className = 'popup-lead__message';
      if (type) messageEl.classList.add('popup-lead__message--' + type);
      messageEl.hidden = !text;
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      lockBody(true);
      if (dialog) {
        try {
          dialog.focus({ preventScroll: true });
        } catch (e) {
          /* ignore */
        }
      }
    }

    function close(reason) {
      if (!isOpen && reason !== 'force') return;
      isOpen = false;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      lockBody(false);

      if (reason === 'dismiss' || reason === 'overlay' || reason === 'escape') {
        writeStamp(STORAGE_DISMISSED, dismissDays);
      }
    }

    function markSuccess() {
      submitting = false;
      writeStamp(STORAGE_SUBMITTED, submitDays);
      writeStamp(STORAGE_DISMISSED, submitDays);
      root.classList.add('is-success');
      setMessage('', '');

      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-busy');
      }

      var autoClose = parseInt(root.dataset.successClose, 10);
      if (!isNaN(autoClose) && autoClose > 0) {
        window.setTimeout(function () {
          close('force');
        }, autoClose);
      }
    }

    function markError(errText) {
      submitting = false;
      setMessage(
        errText || root.dataset.errorMessage || 'Não foi possível enviar. Tente novamente.',
        'error'
      );
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-busy');
      }
    }

    function scheduleOpen() {
      if (shouldSkip(root)) return;
      if (openTimer) window.clearTimeout(openTimer);
      openTimer = window.setTimeout(open, Math.max(0, delay));
    }

    Array.prototype.forEach.call(closeButtons, function (btn) {
      btn.addEventListener('click', function () {
        var reason = btn.getAttribute('data-pl-close') || 'dismiss';
        close(reason);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (!isOpen) return;
      if (event.key === 'Escape') close('escape');
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setMessage('', '');

        var emailInput = form.querySelector('[data-pl-email]') || form.querySelector('input[type="email"]');
        var emailVal = emailInput ? String(emailInput.value || '').trim() : '';

        if (!isValidEmail(emailVal)) {
          setMessage('Informe um e-mail válido.', 'error');
          if (emailInput) emailInput.focus();
          return;
        }

        if (submitting) return;
        submitting = true;

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        }

        var params = {
          to_email: emailVal,
          email: emailVal,
          user_email: emailVal,
          from_email: emailVal,
          reply_to: emailVal,
          to_name: 'Cliente',
          from_name: 'Laeva',
          name: 'Cliente',
          cupom: CUPOM_DE_DESCONTO,
          coupon: CUPOM_DE_DESCONTO,
          message:
            'Novo lead pelo popup da loja\nE-mail: ' +
            emailVal +
            '\nCupom: ' +
            CUPOM_DE_DESCONTO
        };

        sendWithEmailJs(params)
          .then(function (ok) {
            if (ok) {
              markSuccess();
              return;
            }
            return sendWithShopifyContact(emailVal, root.dataset.formTag).then(function (shopOk) {
              if (shopOk) markSuccess();
              else markError();
            });
          })
          .catch(function () {
            return sendWithShopifyContact(emailVal, root.dataset.formTag).then(function (shopOk) {
              if (shopOk) markSuccess();
              else markError();
            });
          });
      });
    }

    root._popupLead = {
      open: open,
      close: function () {
        close('dismiss');
      },
      resetStorage: function () {
        if (!storageAvailable()) return;
        window.localStorage.removeItem(STORAGE_DISMISSED);
        window.localStorage.removeItem(STORAGE_SUBMITTED);
      }
    };

    if (root.dataset.enabled !== 'false') {
      scheduleOpen();
    }
  }

  function unlockBodyIfClosed() {
    if (document.querySelector('[data-popup-lead].is-open')) return;
    document.body.classList.remove('popup-lead-locked');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
  }

  function removeStalePopups(fresh) {
    if (!fresh || !fresh.id) return;
    var nodes = document.querySelectorAll('[data-popup-lead]');
    Array.prototype.forEach.call(nodes, function (node) {
      if (node !== fresh && node.id === fresh.id) node.remove();
    });
    unlockBodyIfClosed();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-popup-lead]');
    Array.prototype.forEach.call(roots, function (root) {
      removeStalePopups(root);
      initPopupLead(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    var popup = document.getElementById('PopupLead-' + sectionId);
    if (!popup || (event.target && event.target.contains && event.target.contains(popup))) return;
    popup.remove();
    unlockBodyIfClosed();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    var root = event.target.querySelector
      ? event.target.querySelector('[data-popup-lead]')
      : null;
    if (!root && event.detail && event.detail.sectionId) {
      root = document.getElementById('PopupLead-' + event.detail.sectionId);
    }
    if (root && root._popupLead) {
      root.dataset.forceOpen = 'true';
      root._popupLead.open();
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    var root = null;
    if (event.detail && event.detail.sectionId) {
      root = document.getElementById('PopupLead-' + event.detail.sectionId);
    }
    if (!root && event.target && event.target.querySelector) {
      root = event.target.querySelector('[data-popup-lead]');
    }
    if (root && root._popupLead) {
      root.dataset.forceOpen = 'true';
      root._popupLead.open();
    }
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    var root = document.getElementById('PopupLead-' + event.detail.sectionId);
    if (root && root._popupLead) {
      root._popupLead.close();
    }
  });
})();
